import { combineReducers } from 'redux';

// Reducers
import { Reducer as authReducer } from '@echotex/api-client-auth';
import { Reducer as navigationReducer } from '@echotex/api-client-navigation';
import { Reducer as utilityReducer } from '@echotex/api-client-utility';
import { IconReducer } from '@core-web/ui/Icon';
import { Reducer as appConfigurationReducer } from '@echotex/app-configuration';

export default combineReducers({
  auth: authReducer,
  navigation: navigationReducer,
  icons: IconReducer,
  utility: utilityReducer,
  appConfig: appConfigurationReducer,
});
